// extracted by mini-css-extract-plugin
export var brand = "_16-8";
export var compact = "_16-5";
export var extraSmall = "_16-6";
export var icon = "_16-0";
export var large = "_16-3";
export var light = "_16-1";
export var medium = "_16-4";
export var outline = "_16-a";
export var primaryDark = "_16-9";
export var primaryLight = "_16-7";
export var primaryModern = "_16-b";
export var success = "_16-2";